<template>
  <div
    v-if="paragraphs?.length"
    class="paragraph grid grid-cols-1 gap-56 md:gap-16"
  >
    <div v-for="(item, index) in paragraphs" :key="index" class="layout-grid">
      <div
        class="col-start-2 col-end-[-2] flex flex-col md:col-end-8 xl:col-end-7"
      >
        <Text
          class="mb-[9px] text-3xl uppercase text-black md:mb-16 md:mt-[5px]"
          :class="{
            'font-bold': isRebranding,
          }"
        >
          {{ item.headline }}
        </Text>
        <div
          v-if="item.description"
          class="rich-text text-md text-grey-dark-01"
          v-html="item.description"
        />
        <div
          class="mb-32 mt-[33px] flex grow flex-col justify-center md:mb-[18px] md:mt-[22px]"
        >
          <ButtonsButton
            v-if="item.link?.uri?.path"
            color="secondary"
            icon-end="arrow-right"
            class="w-fit"
            :to="item.link?.uri?.path"
          >
            {{ $texts('viewMore', 'View more') }}
          </ButtonsButton>
        </div>
      </div>
      <div class="col-start-2 col-end-[-2] md:col-start-8 md:contain-size">
        <MediaImage
          v-if="item.image"
          v-bind="item.image"
          :image-style="imageStyle"
          img-class="w-full h-full object-cover"
          class="h-full"
        />
      </div>

      <hr
        class="col-start-2 col-end-[-2] hidden border-t-grey-light-01 md:block"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { type ParagraphTextImageFragment } from '#graphql-operations'

const { $texts } = useEasyTexts()
const isRebranding = await useFeatureFlag()

defineProps<{
  paragraphs?: ParagraphTextImageFragment[]
}>()

const imageStyle = defineImageStyle({
  type: 'pictures',
  pictures: {
    sm: {
      width: 740,
      aspectRatio: 16 / 9,
    },
    md: {
      width: 430,
      aspectRatio: 16 / 11,
    },
    lg: {
      width: 500,
      aspectRatio: 16 / 9,
    },
    xl: {
      width: 550,
    },
    xxl: {
      width: 640,
      aspectRatio: 16 / 7,
    },
  },
})
</script>

<style lang="scss" scoped>
.button {
  @media (screen(md)) {
    padding-top: 11px;
    padding-bottom: 11px;
  }
}
</style>
